<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii"></a><em>To Charles Spicer<br/>with heartfelt thanks</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?2624736a